<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Campo"
          label-for="campo"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="campo"
            v-model.trim="$v.campo.$model" 
            :state="campoValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="campoFeedback">
            {{ campoInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="obligatorio"
              v-model="obligatorio"
              :value="Boolean(true)"
              :unchecked-value="Boolean(false)">
              Requerido
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="validaDuplicado"
              v-model="validaDuplicado"
              :value="Boolean(true)"
              :unchecked-value="Boolean(false)">
              Valida Duplicados
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          :label-cols="labelCols"
          horizontal>
          <b-form-checkbox 
              id="incluirListado"
              v-model="incluirListado"
              :value="Boolean(true)"
              :unchecked-value="Boolean(false)">
              Mostrar en Listado de Participantes
          </b-form-checkbox>
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'EventoCampoAdicional',
  props: {
    campoAdicional: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      campo: '',
      obligatorio: false,
      validaDuplicado: false,
      incluirListado: false,

      noValidar: true,
      campoValido: null,
      campoInvalidoMsj: '',

      labelCols: 2,
    }
  },
  created() {
    this.campo = this.campoAdicional ? this.campoAdicional.campo : '';
    this.obligatorio = this.campoAdicional ? (/true/i).test(this.campoAdicional.obligatorio) : false;
    this.validaDuplicado = this.campoAdicional ? (/true/i).test(this.campoAdicional.validaDuplicado) : false;
    this.incluirListado = this.campoAdicional ? (/true/i).test(this.campoAdicional.incluirListado) : false;
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'campo' || validarTodos) {
        if (this.$v.campo.$error) {
          this.campoValido = false;
          if (!this.campo.required) {
            this.campoInvalidoMsj = 'Debe ingresar el nombre del campo';
          } else if (!this.$v.campo.maxLength) {
            this.campoInvalidoMsj = 'El nombre del campo solo pueden contener hasta 50 caracteres';
          }      
        } else {
          this.campoValido = null;
          this.campoInvalidoMsj = '';
        }
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        let params = {
          campo: this.campo,
          obligatorio: (/true/i).test(this.obligatorio),
          validaDuplicado: (/true/i).test(this.validaDuplicado),
          incluirListado: (/true/i).test(this.incluirListado)
        }
        this.$emit('close', params)
      }
    },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    campo: {
      required,
      maxLength: maxLength(50)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
